import { createFileRoute } from '@tanstack/react-router'

import { DriverRechargeSuccess } from '@/pages/driver-recharge-success'

export const Route = createFileRoute('/_protected/driver-recharge/success')({
    component: DriverRechargeSuccess,
})
